<template>
  <section :id="id">
    <div class="wrap">
      <div class="section-head">
        <div>
          <h2>{{ title }}</h2>
          <p class="lead">{{ lead }}</p>
        </div>
      </div>
      <div class="rail">
        <div
          v-for="(step, index) in steps"
          :key="index"
          class="step fade-in"
        >
          <div class="num">{{ String(index + 1).padStart(2, '0') }}</div>
          <h3>{{ step.title }}</h3>
          <p>{{ step.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  lead: {
    type: String,
    required: true
  },
  steps: {
    type: Array,
    required: true,
    validator: (value) => {
      return value.every(step =>
        step.hasOwnProperty('title') &&
        step.hasOwnProperty('description')
      );
    }
  }
});
</script>

<style scoped>
/* Rail section styles are inherited from global styles.css */
/* Component-specific overrides can go here if needed */
</style>
